import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { QuoteDataPickerComponent } from './quote-data-picker.component';

@NgModule({
  declarations: [
    QuoteDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    QuoteDataPickerComponent
  ]
})
export class QuoteDataPickerModule { }
